import {FiArrowLeft} from "react-icons/fi";
import {useLocation} from "wouter";

export default function BackButton({to}:{
    to?: string
}){
    const [, navigate] = useLocation();

    return <button onClick={()=>{
        if(to){
            navigate(to)
        }else{
            history.go(-1)
        }
    }} className={"btn btn-ghost opacity-75"}>
        <FiArrowLeft /> Go back
    </button>
}
